import React from 'react'
import { useRouter } from 'next/router'
import SEO from '../../components/seo-head/seo-head'
import { Header } from '../../components/header/header'
import { Footer } from '../../components/footer/footer.component'
import SurfForecast from '../../components/surf-forecast/surf-forecast.component'
import { SURF_SPOTS, forecastContent } from '../../lib/surf-forecast.mjs'
import { siteUrl } from '../../lib/companyInfo'
import { surfForecastSeo, surfForecastBreadcrumb, surfForecastPageSchema } from '../../lib/surf-seo.mjs'
import { forecastPageData } from '../../lib/server/surf-forecast.mjs'

export default function ForecastPage(props) {
  const router = useRouter()
  const seo = surfForecastSeo(props.spot, props.overview)
  return <><SEO seo={seo} router={router} destination={false} breadcrumb={surfForecastBreadcrumb(props.spot, props.overview, siteUrl)} jsonLd={[surfForecastPageSchema(props.spot, props.overview, siteUrl)]} /><Header /><SurfForecast {...props} /><Footer /></>
}
export function getStaticPaths() {
  return { paths: [{ params: { beach: [] } }, ...SURF_SPOTS.map(spot => ({ params: { beach: [spot.slug] } }))], fallback: false }
}
export async function getStaticProps(context) {
  const slug = context.params.beach?.[0] || SURF_SPOTS[0].slug
  const spot = SURF_SPOTS.find(beach => beach.slug === slug)
  if (!spot || (context.params.beach?.length || 0) > 1) return { notFound: true }
  const result = await forecastPageData({ reason: context.revalidateReason, spotSlug: slug })
  return { ...result, props: { ...result.props, spot, overview: !context.params.beach?.length, content: forecastContent(spot, !context.params.beach?.length) } }
}
